import { addDays, differenceInCalendarDays, startOfDay } from 'date-fns';

export const EVENT_STATUS_SORT_ORDER: Record<string, number> = {
  Booking: 1,
  Created: 2,
  Offered: 3,
  Declined: 3,
  Accepted: 4,
  Active: 5,
  InProgress: 6,
  Complete: 7,
  Cancelled: 8,
};

const UNKNOWN_STATUS_ORDER = 99;

export type SortableCalendarEvent = {
  start: string;
  end?: string | null;
  status: string;
  summary: string;
};

/**
 * Same span rule as CalendarEventOrganiser.getCalendarEventLength:
 * inclusive calendar days, minimum 1.
 */
export function getSortableEventLength(event: {
  start: string;
  end?: string | null;
}): number {
  const startDate = startOfDay(new Date(event.start));
  const endDate = startOfDay(addDays(new Date(event.end || event.start), 1));
  const days = differenceInCalendarDays(endDate, startDate);
  return days > 0 ? days : 1;
}

/**
 * Planner stacking order: longer events first, then status, then summary.
 * Offered and Declined share a rank. Unknown statuses sort after known ones.
 */
export function compareCalendarEvents(
  eventA: SortableCalendarEvent,
  eventB: SortableCalendarEvent
): number {
  const durationDiff =
    getSortableEventLength(eventB) - getSortableEventLength(eventA);
  if (durationDiff !== 0) {
    return durationDiff;
  }

  const statusDiff =
    (EVENT_STATUS_SORT_ORDER[eventA.status] ?? UNKNOWN_STATUS_ORDER) -
    (EVENT_STATUS_SORT_ORDER[eventB.status] ?? UNKNOWN_STATUS_ORDER);
  if (statusDiff !== 0) {
    return statusDiff;
  }

  return eventA.summary.localeCompare(eventB.summary);
}
